import { createContext } from "react";

import { AlertContextState } from "./types";

const AlertContext = createContext({} as AlertContextState);

export default AlertContext;
export { ALERT_STATUS } from "./types";
